import { upperFirst } from 'es-toolkit';

import Chip from '@mui/material/Chip';

import { useTranslate } from 'src/locales';

import { chipProps, FiltersBlock, FiltersResult } from 'src/components/filters-result';

// ----------------------------------------------------------------------

export function ProductTableFiltersResult({ filters, totalResults, sx }) {
  const { t } = useTranslate();

  const { state: currentFilters, setState: updateFilters, resetState: resetFilters } = filters;

  const handleRemoveStock = (inputValue) => {
    const newValue = currentFilters.stock.filter((item) => item !== inputValue);
    updateFilters({ stock: newValue });
  };

  const handleRemovePublish = (inputValue) => {
    const newValue = currentFilters.publish.filter((item) => item !== inputValue);
    updateFilters({ publish: newValue });
  };

  return (
    <FiltersResult
      totalResults={totalResults}
      onReset={() => resetFilters()}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
    >
      <FiltersBlock label="Stock" showFilters={!!currentFilters.stock.length}>
        {currentFilters.stock.map((item) => (
          <Chip
            {...chipProps}
            key={item}
            label={upperFirst(item)}
            onDelete={() => handleRemoveStock(item)}
          />
        ))}
      </FiltersBlock>

      <FiltersBlock label="Published" showFilters={!!currentFilters.publish.length}>
        {currentFilters.publish.map((item) => (
          <Chip
            {...chipProps}
            key={item}
            label={t(upperFirst(item))}
            onDelete={() => handleRemovePublish(item)}
          />
        ))}
      </FiltersBlock>
    </FiltersResult>
  );
}
